import { t } from 'i18next';
import { isEmpty } from 'lodash';
import { object, string, mixed, array } from 'yup';

import { INSTANCE_TYPES } from '../../../constants';
import { isSolrCloud, sentenceCase } from '../../../utils/utils';

export const schema = () =>
  object({
    instance: mixed().test(
      'instanceRequired',
      sentenceCase(
        t('selectRequired', {
          ns: 'validations',
          field: t('instance', { ns: 'instance' }),
        })
      ),
      (value) => !isEmpty(value)
    ),
    instanceNodes: array().when('instance', {
      is: (instance) => {
        if (!instance) return false;
        return isSolrCloud(instance.type);
      },
      then: (schema) =>
        schema.min(
          1,
          sentenceCase(
            t('selectRequired', {
              ns: 'validations',
              field: t('instanceNode', { ns: 'instance' }),
            })
          )
        ),
      otherwise: (schema) => schema,
    }),
    downloadTo: string().when('instance', {
      is: (instance) => {
        if (!instance) return false;
        return instance.type === INSTANCE_TYPES.STANDALONE;
      },
      then: (schema) =>
        schema.required(
          sentenceCase(
            t('selectRequired', {
              ns: 'validations',
              field: t('ext.downloadDestination', { ns: 'project' }),
            })
          )
        ),
      otherwise: (schema) => schema,
    }),
    collectionName: string().when(['instance', 'downloadTo'], {
      is: (instance, downloadTo) => {
        if (!instance) return false;
        return (
          instance.type === INSTANCE_TYPES.STANDALONE &&
          downloadTo === 'collection'
        );
      },
      then: (schema) =>
        schema.required(
          sentenceCase(
            t('selectRequired', {
              ns: 'validations',
              field: t('collection', { ns: 'instance' }),
            })
          )
        ),
      otherwise: (schema) => schema,
    }),
  });
